export const getFileName = (filePath: string): string => {
    if (!filePath) {
        return filePath;
    }

    const lastIndex: number = filePath.lastIndexOf("\\");
    if (lastIndex >= 0) {
        return filePath.substr(lastIndex + 1);
    } else {
        return filePath;
    }
}